import { render, staticRenderFns } from "./ConfigurationAddress.vue?vue&type=template&id=60acc240"
import script from "./ConfigurationAddress.vue?vue&type=script&lang=js"
export * from "./ConfigurationAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationAddress.vue?vue&type=style&index=0&id=60acc240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports